// 「語意相近」：把建置期算好的鄰居表（related.json）接到搜尋結果上。純函式，node 可測。
// related.json 格式：{schema, model, keys:[entityKey…], neighbors:{"<idx>":[[<idx>,<score>]…]}}

export function expandRelated(related) {
  const index = new Map(related?.keys?.map((k, i) => [k, i]) || [])
  const keys = related?.keys || []
  const neighbors = related?.neighbors || {}
  return {
    has: key => index.has(key) && !!neighbors[index.get(key)]?.length,
    of(key) {
      const i = index.get(key)
      if (i === undefined) return []
      return (neighbors[i] || []).map(([j, score]) => ({ key: keys[j], score }))
    },
  }
}

// 前 topN 筆結果各自的鄰居，依（名次權重 × 相似度）加總，排除已在結果中的，取前 limit 筆
export function relatedForResults(results, rel, byId, { topN = 5, limit = 8, exclude = new Set() } = {}) {
  const shown = new Set([...exclude, ...results.map(r => r.doc.i)])
  const acc = new Map()
  results.slice(0, topN).forEach((r, rank) => {
    const weight = 1 / (rank + 1)
    for (const n of rel.of(r.doc.i)) {
      if (shown.has(n.key) || !byId.has(n.key)) continue
      const cur = acc.get(n.key) || { key: n.key, score: 0, via: r.doc, viaWeight: 0 }
      cur.score += weight * n.score
      if (weight * n.score > cur.viaWeight) { cur.viaWeight = weight * n.score; cur.via = r.doc }
      acc.set(n.key, cur)
    }
  })
  return [...acc.values()].sort((a, b) => b.score - a.score).slice(0, limit)
    .map(x => ({ doc: byId.get(x.key), score: x.score, via: x.via }))
}

// 查無字面結果：用標題最接近的那筆（分詞後重疊最多）的鄰居
export function nearestByTitle(q, docs, tokenize) {
  const want = new Set(tokenize(q))
  if (!want.size) return null
  let best = null, bestScore = 0
  for (const doc of docs) {
    const have = new Set(tokenize(doc.t))
    let hit = 0
    for (const t of want) if (have.has(t)) hit++
    const score = hit / Math.sqrt(have.size || 1)
    if (hit > 0 && score > bestScore) { best = doc; bestScore = score }
  }
  return best
}

export const relatedOf = (doc, rel, byId, n = 3) => rel.of(doc.i).filter(x => byId.has(x.key)).slice(0, n).map(x => ({ doc: byId.get(x.key), score: x.score }))
